import React, { Component } from 'react'
import { connect } from 'react-redux'
import { SpinnerCard } from '../common/Layout'
import { selectCurrentLocationWithAddress } from '../../redux/modules/selectors'
import SidebarBuildingLocation from '../common/SidebarBuildingLocation'
import { clearError } from '../../redux/modules/locationSearch'

class LocationSidebar extends Component {
  render() {
    const {
      location,
      isLocationLoading,
      availableCredits,
      isAvailableCreditsLoading,
      currentUser,
      clearError
    } = this.props
    return (
      <SpinnerCard
        spinnerActive={isLocationLoading || isAvailableCreditsLoading}
      >
        {location && (
          <SidebarBuildingLocation
            showInstructions
            showCredits={availableCredits > 0}
            location={location}
            currentUser={currentUser}
            availableCredits={availableCredits}
            clearError={clearError}
          />
        )}
      </SpinnerCard>
    )
  }
}

const mapStateToProps = state => {
  const { isLocationLoading } = state.location
  const locationSearch = state.locationSearch
  const location = selectCurrentLocationWithAddress(state)
  const { currentUser } = state.user
  const { availableCredits, isAvailableCreditsLoading } = state.creditHistory

  return {
    location,
    locationSearch,
    isLocationLoading,
    availableCredits,
    isAvailableCreditsLoading,
    currentUser
  }
}

const mapDispatchToProps = {
  clearError
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LocationSidebar)
